import { authHeader } from '../../_helpers';
import axios from 'axios';

export const VirtualTeamService = {
    list_api_service,
    create_api_service,
    team_list_service,
    delete_team_name,
    member_list_api,
    member_add_api,
    member_update_api,
    shared_with_api,
    share_team_api,
    share_del_api,
    edit_api_service,

    filterTeamApi
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function filterTeamApi(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/team/member/filter/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function edit_api_service(data) {
    token = localStorage.getItem('access_token')    
    return axios.put(`/analytics/virtual_team/update/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function share_del_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/share/remove/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


function share_team_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/share/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function shared_with_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/shared_with/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function member_update_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/member/update/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function member_add_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/member/add/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function member_list_api(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/member/list/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function delete_team_name(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/delete/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function team_list_service(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/list/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function list_api_service(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/participant/list/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}

function create_api_service(data) {
    token = localStorage.getItem('access_token')    
    return axios.post(`/analytics/virtual_team/create/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/VirtualTeam/VirtualTeam.service.js